import React, { useState, useEffect } from "react";
import { Checkbox } from 'primereact/checkbox';

export const Periodes = ({ type, exercice, dateRange, onValueChange, disabled }) => {

    const februaryDateEnd = (exercice) => {
        if(isLeapYear(exercice)) {
            return '02/29/' + exercice;
        }
        return '02/28/' + exercice;
    };

    const isLeapYear = (year) => {
        return ((year % 4 == 0) && (year % 100 != 0)) || (year % 400 == 0);
    }

    const semestres = [
        { key: 1, label: '1er sem. (janv., févr., mars, avr., mai, juin)', start: '01/01/'+exercice, end: '06/30/'+exercice },
        { key: 2, label: '2e sem. (juil., août, sept., oct., nov., déc.)', start: '07/01/'+exercice, end: '12/31/'+exercice }
    ];

    const trimestres = [
        { key: 1, label: '1er trim. (janv., févr., mars)', start: '01/01/'+exercice, end: '03/31/'+exercice },
        { key: 2, label: '2e trim. (avr., mai, juin)', start: '04/01/'+exercice, end: '06/30/'+exercice },
        { key: 3, label: '3e trim. (juil., août, sept.)', start: '07/01/'+exercice, end: '09/30/'+exercice },
        { key: 4, label: '4e trim. (oct., nov., déc.)', start: '10/01/'+exercice, end: '12/31/'+exercice }
    ];

    const mois = [
        { key: 1, label: 'Janvier', start: '01/01/'+exercice, end: '01/31/'+exercice },
        { key: 2, label: 'Février', start: '02/01/'+exercice, end: februaryDateEnd(exercice) },
        { key: 3, label: 'Mars', start: '03/01/'+exercice, end: '03/31/'+exercice },
        { key: 4, label: 'Avril', start: '04/01/'+exercice, end: '04/30/'+exercice },
        { key: 5, label: 'Mai', start: '05/01/'+exercice, end: '05/31/'+exercice },
        { key: 6, label: 'Juin', start: '06/01/'+exercice, end: '06/30/'+exercice },
        { key: 7, label: 'Juillet', start: '07/01/'+exercice, end: '07/31/'+exercice },
        { key: 8, label: 'Août', start: '08/01/'+exercice, end: '08/31/'+exercice },
        { key: 9, label: 'Septembre', start: '09/01/'+exercice, end: '09/30/'+exercice },
        { key: 10, label: 'Octobre', start: '10/01/'+exercice, end: '10/31/'+exercice },
        { key: 11, label: 'Novembre', start: '11/01/'+exercice, end: '11/30/'+exercice },
        { key: 12, label: 'Décembre', start: '12/01/'+exercice, end: '12/31/'+exercice }
    ];

    const initSelection = () => {
        let selection = [];
        if(dateRange && dateRange.length > 1) {

            const dateStart = [(dateRange[0].getMonth()+1).toString().padStart(2, '0'), dateRange[0].getDate().toString().padStart(2, '0'), dateRange[0].getFullYear()].join('/');
            const dateEnd = [(dateRange[1].getMonth()+1).toString().padStart(2, '0'), dateRange[1].getDate().toString().padStart(2, '0'), dateRange[1].getFullYear()].join('/');

            let dateStartKey = 0;
            let dateEndKey = -1;

            switch (type) {
                case 'SEMESTRES':
                    semestres.forEach(p => {
                        if(p.start === dateStart) dateStartKey = p.key;
                        if(p.end === dateEnd) dateEndKey = p.key;
                    });
                    break;
                case 'TRIMESTRES':
                    trimestres.forEach(p => {
                        if(p.start === dateStart) dateStartKey = p.key;
                        if(p.end === dateEnd) dateEndKey = p.key;
                    });
                    break;
                case 'MOIS':
                    mois.forEach(p => {
                        if(p.start === dateStart) dateStartKey = p.key;
                        if(p.end === dateEnd) dateEndKey = p.key;
                    });
                    break;
                default:
                    break;
            }

            for(let i = dateStartKey; i <= dateEndKey; i++) {
                selection.push(i);
            }
        }
        return selection;
    };

    const [checked, setChecked] = useState(initSelection);

    const getRef = (type) => {
        switch (type) {
            case 'SEMESTRES':
                return semestres;
            case 'TRIMESTRES':
                return trimestres;
            case 'MOIS':
                return mois;
            default:
                return [];
        }
    }

    const onPeriodeChange = (e) => {
        let selectedPeriodes = [...checked];

        if (e.checked && !checked.includes(e.value)) {
            selectedPeriodes.push(e.value);

        } else if (!e.checked) {
            selectedPeriodes.splice(selectedPeriodes.indexOf(e.value), 1);
        }

        selectedPeriodes.sort((a, b) => a - b);
        selectedPeriodes = autoCheck(selectedPeriodes);

        setChecked(selectedPeriodes);

        onValueChange(selectedPeriodes.length > 0 ? getDateRange(type, selectedPeriodes) : []);

    }

    const autoCheck = (periodes) => {
        let newPeriodes = periodes.concat();
        if(periodes.length >= 2 && (periodes[periodes.length-1] - periodes[0] >= 2)) {
            for(let i = periodes[0]+1; i < periodes[periodes.length-1]; i++) {
                if(!periodes.includes(i))
                    newPeriodes.push(i);
            }
            newPeriodes.sort((a, b) => a - b);
        }
       return newPeriodes;
    }

    const getDateRange = (type, periodes) => {
        if(periodes.length === 0) {
            return [null, null];
        }

        switch (type) {
            case 'SEMESTRES':
                return [new Date(semestres[periodes[0]-1].start), new Date(semestres[periodes[periodes.length-1]-1].end)];
            case 'TRIMESTRES':
                return [new Date(trimestres[periodes[0]-1].start), new Date(trimestres[periodes[periodes.length-1]-1].end)];
            case 'MOIS':
                return [new Date(mois[periodes[0]-1].start), new Date(mois[periodes[periodes.length-1]-1].end)];
            default:
                return [null, null];
        }
    }

    return (
        <div>
            {
                getRef(type).map((p) => {
                    return (
                        <div key={p.key} className="field-checkbox">
                            <Checkbox inputId={'p'+p.key} name="periode" value={p.key} onChange={onPeriodeChange} checked={checked.includes(p.key)} disabled={disabled} />
                            <label htmlFor={'p'+p.key}>{p.label}</label>
                        </div>
                    )
                })
            }
        </div>
    )
}
